import { IUseTaskManagerStore, WidgetState } from "../../../store/useTaskManagerStore";

export const useTaskManagerWidget = () => {
  const toggleWidget = (
    widgetState: IUseTaskManagerStore["widgetState"],
    setWidgetState: IUseTaskManagerStore["setWidgetState"],
  ) => {
    const canExpand = [WidgetState.collapsed, WidgetState.hidden].includes(widgetState);
    if (canExpand) {
      return setWidgetState(WidgetState.expanded);
    }
    setWidgetState(WidgetState.collapsed);
  };

  const hideWidget = (setWidgetState: IUseTaskManagerStore["setWidgetState"]) => {
    setWidgetState(WidgetState.hidden);
  };

  const isExpanded = (widgetState: IUseTaskManagerStore["widgetState"]) =>
    widgetState === WidgetState.expanded;

  const isCollapsed = (widgetState: IUseTaskManagerStore["widgetState"]) =>
    widgetState === WidgetState.collapsed;

  const setWidgetClasses = (
    widgetState: IUseTaskManagerStore["widgetState"],
    updated: IUseTaskManagerStore["updated"],
    completed: IUseTaskManagerStore["completed"],
  ) => {
    let widgetClass = "task-manager-widget";
    if (updated) widgetClass += " updated";
    if (completed) widgetClass += " completed";
    if (widgetState === WidgetState.expanded) widgetClass += " expanded";
    if (widgetState === WidgetState.hidden) widgetClass += " hide";
    return widgetClass;
  };

  return {
    toggleWidget,
    hideWidget,
    setWidgetClasses,
    isExpanded,
    isCollapsed,
  };
};
